import globals from "../config/appconfig";
import axios from "axios";
import Utils from "../utils/Utils";

export default class ReportEpatiteService{
    static urlReportEpatite = globals["app-url-backend-segnalazioni"] + "/reportEpatite"

    static getReportEpatite(params) {
        let querystring = "?";

        Object.keys(params).forEach(function (key) {
            querystring += key + "=" + params[key] + "&";
        });
        querystring = querystring.substring(0, querystring.length - 1);

        return axios.get(this.urlReportEpatite + querystring)
    }

    static postInserimentoReportEpatite(jsonInsert) {

        return axios.post(this.urlReportEpatite, jsonInsert)

    }

    static deleteReportEpatite(idReport){
        return axios.delete(this.urlReportEpatite + "/" + idReport)
    }

    static putReportEpatite(idReport, jsonInsert){
        return axios.put(this.urlReportEpatite + "/" + idReport , jsonInsert)
    }

    static getExportReportEpatite(params){
        let querystring = "?";

        Object.keys(params).forEach(function (key) {
            querystring += key + "=" + params[key] + "&";
        });
        querystring = querystring.substring(0, querystring.length - 1);

        return axios.get(this.urlReportEpatite + "/downloadcsv"+ querystring)
    }

}
